import { render, staticRenderFns } from "./Sbdata.vue?vue&type=template&id=421cd490&scoped=true&"
import script from "./Sbdata.vue?vue&type=script&lang=js&"
export * from "./Sbdata.vue?vue&type=script&lang=js&"
import style0 from "./Sbdata.vue?vue&type=style&index=0&id=421cd490&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421cd490",
  null
  
)

export default component.exports